<template>
    <div>
        <div  class="container-fluid">
            <div class="layout-content">
                <div class="layout-main">
                    <div class="box-body text-center">
                            <p>
                                <img src="https://p1.meituan.net/codeman/1e54ebe59c5c072b48d73c36ae8ec4b640004.jpg" alt="">
                            </p>
                            <p class="text-center">
                            </p>
                    </div>
                </div>
            </div>
        </div>
        <footerBar></footerBar>
    </div>
</template>
<script>
import { NavBar, FooterBar, Sidebar } from 'components/layout'
export default {
    components: {
        NavBar,
        FooterBar,
        Sidebar
    },
    methods: {

    },
    data () {
        return {}
    }
}
</script>

<style lang="css" scoped>
.box-body {
    margin: 15%;
}
</style>



// WEBPACK FOOTER //
// 403.vue?2b5be824